import { render } from "./ContentBuilderDataset.vue?vue&type=template&id=20b8fce6"
import script from "./ContentBuilderDataset.vue?vue&type=script&lang=js"
export * from "./ContentBuilderDataset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__